import { ThankYouBasketFragment } from '@generated/gql/graphql';

const getNetworkType = (basket: ThankYouBasketFragment) => {
  const broadbandRequirement = basket?.selectedQuotes
    .flatMap((quote) => quote.requirements)
    .find(
      (quoteRequirement) =>
        quoteRequirement.requirement?.__typename ===
        'BroadbandQuoteRequirements'
    )?.requirement;

  const networkType =
    broadbandRequirement?.__typename === 'BroadbandQuoteRequirements'
      ? (broadbandRequirement.lineCharacteristics?.networkType ?? undefined)
      : undefined;
  return networkType;
};

export { getNetworkType };
